module.exports = __webpack_public_path__ + "static/media/WindowletteringdetailJettieRaesAsheville2020.0cbec000.webp";